export interface DivisorMuestra {
  id: number;
  laboratorio_id: number;
  tipo_divisor_muestra_id: number;
}

export interface TipoDivisorMuestra {
  id: number;
  nombre: string;
}

export function createEmptyDivisorMuestra(): DivisorMuestra {
  return {
    id: null,
    laboratorio_id: null,
    tipo_divisor_muestra_id: null
  };
}

export function createDivisorMuestra(params: any): DivisorMuestra {
  return {
    ...createEmptyDivisorMuestra(),
    ...params
  };
}
